export default __webpack_public_path__ + "static/media/Churros - proportioned_170.4bfc8521.jpg";